import { Link } from 'react-router-dom';

import { ProfileEditIcon } from '@/components/ui/svg/ProfileIcons';
import { useUser } from '@/hooks/useUser';
import { ConsumerRoutes } from '@/interfaces/routes/ConsumerRoutes';

const Profile = () => {
	const { user } = useUser();
	return (
		<div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6">
			<div className="flex justify-between items-center border-b pb-4">
				<div>
					<h2 className="text-lg font-semibold">Profile</h2>
					<p className="text-gray-400 text-sm">{user?.username || ''}</p>
				</div>
				<Link to={ConsumerRoutes.AddProfile}>
					<button>
						<ProfileEditIcon />
					</button>
				</Link>
			</div>

			<div className="mt-4 space-y-4">
				{[
					{ label: 'Full Name', value: user?.name || '-' },
					{ label: 'Email Address', value: user?.username || '-' },
					{ label: 'Phone', value: user?.phone || '-' },
					{ label: 'Location', value: user?.location || '-' },
					{ label: 'Shipping Address', value: user?.shippingAddress || '-' },
					{ label: 'Product Interest', value: user?.productInterest || '-' },
				].map((item, index) => (
					<div
						key={index}
						className="flex flex-col sm:flex-row sm:justify-between text-gray-700"
					>
						<p className="font-medium">{item.label}</p>
						<p className="text-gray-500 break-words max-w-full sm:max-w-md md:max-w-lg lg:max-w-xl">
							{item.value}
						</p>
					</div>
				))}
			</div>
		</div>
	);
};

export default Profile;
